import type { ReactNode } from 'react';

import type { IGameLayoutLabels } from './labels';

export interface IPlayer {
  id: string;
  name: string;
  avatarUrl?: string;
  symbol: string;
  symbolContent?: ReactNode;
}

export interface IGameLayoutProps {
  player1: IPlayer;
  player2: IPlayer;
  activePlayerId: string | null;
  /** Remaining time for the player1 card (local "you" in online play). */
  player1TimeLeftMs: number;
  /** Remaining time for the player2 card (opponent). */
  player2TimeLeftMs: number;
  turnDurationMs: number;
  gameContent: ReactNode;
  gameColumnClassName?: string;
  gameName?: string;
  rulesContent?: string;
  labels: IGameLayoutLabels;
  onSurrender?: () => void;
  layoutVariant?: 'default' | 'fullWidth';
  fullWidthMobilePlayersPreset?: 'default' | 'compactRow';
  disableHorizontalPadding?: boolean;
}

export const GAME_SOUND_MUTED_KEY = 'skillarea_gameSoundMuted';
